export const SET_LOADING = `platoons/set_loading`;
export const SET_PLATOONS = `platoons/set_platoons`;
export const UPDATE_PLATOON = `platoons/update_platoon`;
export const DELETE_PLATOON = `platoons/delete_platoon`;



// WEBPACK FOOTER //
// ./src/store/base/platoons/types.js